
import { BrowserRouter , HashRouter, useNavigate, Routes, Route, Link } from 'react-router-dom';
import React, { Fragment } from 'react';

function AppWrapper(props) {

	let { children } = props;
	if (!Array.isArray(children))
		children = [ children ];


	const routes = [];
	const beforeRoutes = [];
	const afterRoutes = [];
	let routeEncountered = false;


	children.forEach((child, i) => {

		if (child && child.props && child.props.path && child.props.component) {

			const { props={} } = child;

			const Component = props.component || Fragment;

			const { path, key=i } = props;
			const route = <Route key={key} exact path={path} element={<Component />} />
			routes.push(route);
			routeEncountered = true;

		} else {
			if (routeEncountered)
				afterRoutes.push(child);
			else
				beforeRoutes.push(child);
		}
		
	});


	let Router;

	switch (props.router) {

		case 'hash':
			Router = HashRouter;
			break;

		default:
			Router = BrowserRouter;

	}

	return (
		<Router>

			{beforeRoutes}

			<Wrapper>

				<Routes>
					{routes}
				</Routes>

			</Wrapper>

			{afterRoutes}
			
		</Router>
	); 
}


function Wrapper(props) {

  window.App.redirect = useNavigate();

  return <Fragment>
    {props.children}
  </Fragment>
}


function AppRoute(props) {
   return <Fragment />
}



window.App = {};

export default AppWrapper;

export {
  AppRoute as Route,
  Link
}